import { Box, Divider, Typography } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import './style.css'
import { useNavigate } from "react-router-dom";
// import Chart from 'react-apexcharts'
import dashboardAPI from "../../Network/Dashboard";
import Cookies from 'universal-cookie';
import { toast } from 'react-toastify';
import Preloading from '../../Pages/Preload/Preloading';
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { selectRoles } from "../../reduxStore/RolesReducer";
import { setTransactionFilters } from "../../reduxStore/SettingsReducer";
import Search from "./Search";
import branchAPI from "../../Network/Branch";
import transactionStatusAPI from "../../Network/TransactionStatus";
import CustomeFilter from "../Grid/Components/CustomeFilter";
import PieChart from "./Components/PieChart";
import StackChart from "./Components/StackChart";
import transactionAPI from "../../Network/Transaction";
import mizanListAPI from "../../Network/MizanList";

const cookies = new Cookies();



const todayStart = new Date();
const yesterday = new Date(todayStart);
yesterday.setDate(yesterday.getDate() - 1);
yesterday.setHours(0, 0, 0, 0);

const todayEnd = new Date();
todayEnd.setHours(23, 59, 59, 999);
export default function Dashboard() {
  const maintheme = useSelector((state) => state.themeData.maintheme);
  const systemSettings = useSelector((state) => state.systemSettings);
  const roles = useSelector(selectRoles);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [t] = useTranslation("common");

  const [reload, setReload] = useState(false)
  const [branches, setBranches] = useState([])
  const [loadingBranches, setLoadingBranches] = useState(true)

  const [mizans, setMizans] = useState([])
  const [loadingMizans, setLoadingMizans] = useState(true)

  const [transactionStatuses, setTransactionStatuses] = useState([])
  const [loadingTransactionStatuses, setLoadingTransactionStatuses] = useState(true)

  const [loading, setLoading] = useState(true)
  const [dashboardObject, setDashboardObject] = useState({
    total_external: 0,
    total_internal: 0,
    total_unknown_type: 0,
    total_external_monitored: 0,
    total_external_not_monitored: 0,
    total_external_monitored_completed: 0,
    total_external_monitored_in_road: 0,
    all_transactions: 0,
    total_audited: 0,
    total_not_audited: 0
  })
  const [chartObject, setChartObject] = useState({
    transaction_types_pie: {
      series: [],
      labels: [],
      colors: []
    },
    external_monitored_pie: {
      series: [],
      labels: [],
      colors: []
    },
    external_progress_pie: {
      series: [],
      labels: [],
      colors: []
    },
    weight_totals_bar: {
      series: [],
      labels: []
    }
  })
  const [auditedData, setAuditedData] = useState({
    auditedData: [],
    auditedLabels: []
  })
  const [weightData, setWeightData] = useState({
    weightData: [],
    weightLabels: []
  })
  const [mizanChartData, setMizanChartData] = useState({
    series: [],
    labels: []
  })
  const [weightDataCat1, setWeightDataCat1] = useState({
    weightData: [],
    weightLabels: []
  })
  const [weightDataCat2, setWeightDataCat2] = useState({
    weightData: [],
    weightLabels: []
  })
  const [mizanChartDataCat1, setMizanChartDataCat1] = useState({
    series: [],
    labels: []
  })
  const [mizanChartDataCat2, setMizanChartDataCat2] = useState({
    series: [],
    labels: []
  })
  const [filters, setFilters] = useState({
    unit: null,
    unit_id: "",
    sourceGeofence: null,
    source_geofence_id: "",
    destinationGeofence: null,
    destination_geofence_id: "",
    route: null,
    route_id: "",
    creation_date_from: moment().subtract(1, "day").startOf("day").format('YYYY-MM-DD') + " 00:00:00",
    creation_date_to: moment().endOf('day').format('YYYY-MM-DD') + " 23:59:59",
    creationDateFrom: yesterday,
    creationDateTo: todayEnd,
    export_excel: false,
    note: "",
    destination_geofence_name: "",
    source_geofence_name: "",
    all_time: 0
  })
  const globalLoading = useSelector(state => state.settingsData.globalLoading)
  const controllerRef = useRef(new AbortController());


  const getResources = () => {
    const headerObject = {
      username: cookies.get("user_name") ? cookies.get("user_name") : null,
      user_id: cookies.get("user_id") ? cookies.get("user_id") : null,
      account_name: cookies.get("account_name") ? cookies.get("account_name") : null,
      account_id: cookies.get("account_id") ? cookies.get("account_id") : null,
      authHash: cookies.get("authHash") ? cookies.get("authHash") : null,
      sid: cookies.get("sid") ? cookies.get("sid") : null,
      baseurl: cookies.get("baseUrl") ? cookies.get("baseUrl") : null,
      id: cookies.get("id") ? cookies.get("id") : null,
    }

    branchAPI.getBranchList({
      params: {
        ...headerObject,
      }

    }).then(branchesResult => {
      if (branchesResult.status && branchesResult?.data?.data) {
        // Handle both direct array and paginated response
        const branchData = Array.isArray(branchesResult?.data?.data)
          ? branchesResult?.data?.data
          : branchesResult?.data?.data?.data || [];
        setBranches(branchData)
      } else {
        setBranches([]);
      }
      setLoadingBranches(false);
    }).catch(error => {
      console.log(error);
      setBranches([]);
      setLoadingBranches(false);
    }).finally(() => {
      setLoadingBranches(false);
    })

    transactionStatusAPI.getTransactionStatusList({
      params: {
        ...headerObject,
      }

    }).then(transactionStatusesResult => {
      if (transactionStatusesResult.status && transactionStatusesResult?.data?.data) {
        const statusData = Array.isArray(transactionStatusesResult?.data?.data)
          ? transactionStatusesResult?.data?.data
          : transactionStatusesResult?.data?.data?.data || [];
        setTransactionStatuses(statusData)
      } else {
        setTransactionStatuses([]);
      }
      setLoadingTransactionStatuses(false);
    }).catch(error => {
      console.log(error);
      setTransactionStatuses([]);
      setLoadingTransactionStatuses(false);
    }).finally(() => {
      setLoadingTransactionStatuses(false);
    })

    mizanListAPI.getMizanList({
      params: {
        ...headerObject,
      }
    }).then(mizansResult => {
      if (mizansResult.status && mizansResult?.data?.data) {
        // Handle both direct array and paginated response
        const mizanData = Array.isArray(mizansResult?.data?.data)
          ? mizansResult?.data?.data
          : mizansResult?.data?.data?.data || [];
        setMizans(mizanData)
      } else {
        setMizans([]);
      }
      setLoadingMizans(false);
    }).catch(error => {
      console.log(error);
      setLoadingMizans(false);
    }).finally(() => {
      setLoadingMizans(false);
    })

  }


  useEffect(() => {
    getResources()
    return () => {

    }
  }, [])

  useEffect(() => {
    loadData()
    // setLoading(false)
  }, [reload])

  const loadData = async (searchParams) => {
    if (
      cookies.get("active_session") &&
      cookies.get("active_session") == "yes"
    ) {
      let object = {
        username: cookies.get("user_name") ? cookies.get("user_name") : null,
        user_id: cookies.get("user_id") ? cookies.get("user_id") : null,
        account_name: cookies.get("account_name") ? cookies.get("account_name") : null,
        account_id: cookies.get("account_id") ? cookies.get("account_id") : null,
        authHash: cookies.get("authHash") ? cookies.get("authHash") : null,
        sid: cookies.get("sid") ? cookies.get("sid") : null,
        baseurl: cookies.get("baseUrl") ? cookies.get("baseUrl") : null,
        id: cookies.get("id") ? cookies.get("id") : null,

        search: "",
        ...searchParams,
        ...filters
      };

      if (!filters?.all_time && filters?.creation_date_from && filters?.creation_date_to) {
        const start = moment(filters.creation_date_from);
        const end = moment(filters.creation_date_to);
        if (end.diff(start, 'months', true) > 1.05) { // 1.05 to allow for slightly more than 30 days
          toast.error("يجب ان لا تزيد الفترة المختارة عن شهر واحد");
          return;
        }
      }

      setLoading(true);

      const result = await dashboardAPI.dashboard({
        params: object,
        signal: controllerRef.current?.signal,
      });


      if (result.status && result?.data?.data) {
        setDashboardObject({
          ...dashboardObject,
          ...result?.data?.data
        })
        setChartObject({
          transaction_types_pie: {
            series: [result?.data?.data?.total_external || 0, result?.data?.data?.total_internal || 0, result?.data?.data?.total_unknown_type || 0],
            labels: ['خارجي', 'داخلي', 'غير معروف'],
            colors: [maintheme?.primary, maintheme?.yellow, maintheme?.red]
          },
          external_monitored_pie: {
            series: [result?.data?.data?.total_external_monitored || 0, result?.data?.data?.total_external_not_monitored || 0],
            labels: ['مراقب خارجي', 'غير مراقب خارجي'],
            colors: [maintheme?.primary, maintheme?.red]
          },
          external_progress_pie: {
            series: [result?.data?.data?.total_external_monitored_completed || 0, result?.data?.data?.total_external_monitored_in_road || 0],
            labels: ['مكتمل خارجي', 'في الطريق خارجي'],
            colors: [maintheme?.primary, maintheme?.yellow]
          },

        })

      } else {

        if (result?.data?.data?.message) {
          toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
        }
        else if (!result?.data?.error) {
          toast.error(t("NETWORK_MESSAGES.unknownError"));
          return;
        }
        if (result && result?.data && result?.data?.data?.message) {
          if (result?.data?.data?.message?.text == "unauthorized to complete") {
            navigate("/redirect");
          }
        }
      }

      const weightResult = await dashboardAPI.getWeightTotalsPerMizan({
        params: object,
        signal: controllerRef.current?.signal,
      });

      if (weightResult.status && weightResult?.data?.data && Array.isArray(weightResult?.data?.data) && weightResult?.data?.data.length > 0) {
        const data = weightResult?.data?.data;

        const processWeights = (rawData) => {
          const labels = rawData.map(item => item.mizan_name || 'غير معروف');
          const externalData = rawData.map(item => parseFloat(((item.total_external_liters || 0) / 1000).toFixed(2)));
          const internalData = rawData.map(item => parseFloat(((item.total_internal_liters || 0) / 1000).toFixed(2)));
          const cumulativeData = rawData.map(item => {
            const internal = parseFloat(item.total_internal_liters || 0);
            const external = parseFloat(item.total_external_liters || 0);
            const adjustment = parseFloat(item.total_adjustment_liters || 0);
            return parseFloat(((internal - external + adjustment) / 1000).toFixed(2));
          });
          return { labels, externalData, internalData, cumulativeData };
        };

        // All Mizans
        const total = processWeights(data);
        setWeightData({
          weightData: [
            { name: 'خارجي (بالطن)', data: total.externalData },
            { name: 'داخلي (بالطن)', data: total.internalData }
          ],
          weightLabels: total.labels
        })
        setMizanChartData({
          series: [
            { name: 'خارجي (بالطن)', data: total.externalData },
            { name: 'داخلي (بالطن)', data: total.internalData },
            { name: 'متراكم (بالطن)', data: total.cumulativeData }
          ],
          labels: total.labels
        })

        // Category 1: محطة تحويلية (ID 1)
        const dataCat1 = data.filter(item => item.port_category_id === 1);
        const resCat1 = processWeights(dataCat1);
        setWeightDataCat1({
          weightData: [
            { name: 'خارجي (بالطن)', data: resCat1.externalData },
            { name: 'داخلي (بالطن)', data: resCat1.internalData }
          ],
          weightLabels: resCat1.labels
        })
        setMizanChartDataCat1({
          series: [
            { name: 'خارجي (بالطن)', data: resCat1.externalData },
            { name: 'داخلي (بالطن)', data: resCat1.internalData },
            { name: 'متراكم (بالطن)', data: resCat1.cumulativeData }
          ],
          labels: resCat1.labels
        })

        // Category 2: مكبس (ID 2)
        const dataCat2 = data.filter(item => item.port_category_id === 2);
        const resCat2 = processWeights(dataCat2);
        setWeightDataCat2({
          weightData: [
            { name: 'خارجي (بالطن)', data: resCat2.externalData },
            { name: 'داخلي (بالطن)', data: resCat2.internalData }
          ],
          weightLabels: resCat2.labels
        })
        setMizanChartDataCat2({
          series: [
            { name: 'خارجي (بالطن)', data: resCat2.externalData },
            { name: 'داخلي (بالطن)', data: resCat2.internalData },
            { name: 'متراكم (بالطن)', data: resCat2.cumulativeData }
          ],
          labels: resCat2.labels
        })

      } else {
        // Set empty data if no results
        setWeightData({ weightData: [], weightLabels: [] })
        setMizanChartData({ series: [], labels: [] })
        setWeightDataCat1({ weightData: [], weightLabels: [] })
        setMizanChartDataCat1({ series: [], labels: [] })
        setWeightDataCat2({ weightData: [], weightLabels: [] })
        setMizanChartDataCat2({ series: [], labels: [] })
      }

      setLoading(false);
    } else {
      navigate("/redirect");
    }
  };


  const showDetailsFromIndex = (index, type) => {

    let dashboardFilters = {}
    const CommonFilters = {
      creation_date_to: filters?.creation_date_to,
      creation_date_from: filters?.creation_date_from,
      creationDateFrom: filters?.creationDateFrom,
      creationDateTo: filters?.creationDateTo,
      all_time: filters?.all_time,
      branch_ids: filters?.branch_ids,
      branches_selected: filters?.branches_selected,
      mizan_list_ids: filters?.mizan_list_ids,
      mizans_selected: filters?.mizans_selected,
    }

    if (type == 1) { // External monitored pie
      dashboardFilters = {
        ...CommonFilters,
        lifecycle_type: 1,
        is_monitored: index == 0 ? 1 : 0
      }
    }
    else if (type == 2) { // External progress pie
      dashboardFilters = {
        ...CommonFilters,
        lifecycle_type: 1,
        is_monitored: 1,
        is_complete: index == 0 ? 1 : 0
      }
    }
    else if (type == 3) { // Transaction types pie
      dashboardFilters = {
        ...CommonFilters,
        lifecycle_type: index == 0 ? 1 : (index == 1 ? 2 : 'unknown') // External, Internal, or Unknown
      }
    }
    // Save state to local storage
    localStorage.setItem('dashboardFilters', JSON.stringify(dashboardFilters));
    // setLoading(true)
    // Get the current root URL
    const currentRootURL = window.location.origin;

    // Append "system/transactions" to the root URL
    const newURL = `${currentRootURL}/system/transactions`;

    // Open the new tab with the constructed URL
    const newTab = window.open(newURL, '_blank');

    // navigate("/system/transactions");
  }
  const showDetails = (object) => {
    dispatch(setTransactionFilters({
      creation_date_to: filters?.creation_date_to,
      creation_date_from: filters?.creation_date_from,
      creationDateFrom: filters?.creationDateFrom,
      creationDateTo: filters?.creationDateTo,
      all_time: filters?.all_time,
      ...object
    }))


    navigate("/system/transactions");
  }
  const clearFilterFunction = () => {
    setFilters({
      name: "",
      code: "",
      transaction_id: "",
      transaction_number: "",
      type_id: null,
      wialon_id: null,
      export_excel: false,
      creation_date_from: moment().subtract(1, "day").startOf("day").format('YYYY-MM-DD') + " 00:00:00",
      creation_date_to: moment().endOf('day').format('YYYY-MM-DD') + " 23:59:59",
      creationDateFrom: yesterday,
      creationDateTo: todayEnd,
      export_excel: false,
      note: "",
      destination_geofence_name: "",
      source_geofence_name: "",
      all_time: 0
    })
  }
  const searchFunction = () => {
    setReload(!reload)

  };

  return (
    loading || globalLoading ? <Preloading dashboardMode={true} />
      :
      // Replace the section starting from the main Box after the date display
      // with this corrected structure:

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column', // Changed from 'row' to 'column'
          gap: 3,
          marginBottom: 3
        }}
      >
        <CustomeFilter
          clearFunction={clearFilterFunction}
          searchFunction={searchFunction}
          resultLength={dashboardObject?.all_transactions}
          LeftHeaderComponent={<Box>
            <Typography sx={{ fontFamily: 'Cairo', fontWeight: 'bold', fontSize: '22px' }}>{t('SIDEMENU.dashboard')}</Typography>
          </Box>}
        >
          <Search
            filters={filters}
            setFilters={setFilters}
            loadingBranches={loadingBranches}
            branches={branches}
            loadingMizans={loadingMizans}
            mizans={mizans}
            transactionStatuses={transactionStatuses}
            loadingTransactionStatuses={loadingTransactionStatuses}
          />
        </CustomeFilter>
        {/* Row 1: First two pie charts */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 3,
            width: '100%'
          }}
        >
          <Box sx={{
            width: '50%',
            height: '395px',
            backgroundColor: '#fff',
            boxShadow: '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '5px',
            position: 'relative'
          }}>
            <span
              onClick={() => { }}
              className="hover-style"
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                cursor: 'pointer',
                paddingLeft: '10px',
                paddingRight: '10px',
                fontSize: '20px',
              }}>{`انواع المستندات ${dashboardObject?.total_external + dashboardObject?.total_internal + dashboardObject?.total_unknown_type}`}</span>
            {chartObject?.transaction_types_pie?.series?.length > 0 && chartObject?.transaction_types_pie?.labels?.length > 0 ? (
              <PieChart redirectIndex={(index) => showDetailsFromIndex(index, 3)} series={chartObject?.transaction_types_pie?.series} labels={chartObject?.transaction_types_pie?.labels} colors={chartObject?.transaction_types_pie?.colors} />
            ) : (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Typography>لا توجد بيانات</Typography>
              </Box>
            )}
          </Box>

          <Box sx={{
            width: '50%',
            height: '395px',
            backgroundColor: '#fff',
            boxShadow: '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '5px',
            position: 'relative'
          }}>
            <span
              onClick={() => { }}
              className="hover-style"
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                cursor: 'pointer',
                paddingLeft: '10px',
                paddingRight: '10px',
                fontSize: '20px',
              }}>{`تفاصيل المستندات الخارجية ${dashboardObject?.total_external_monitored + dashboardObject?.total_external_not_monitored}`}</span>
            {chartObject?.external_monitored_pie?.series?.length > 0 && chartObject?.external_monitored_pie?.labels?.length > 0 ? (
              <PieChart redirectIndex={(index) => showDetailsFromIndex(index, 1)} series={chartObject?.external_monitored_pie?.series} labels={chartObject?.external_monitored_pie?.labels} colors={chartObject?.external_monitored_pie?.colors} />
            ) : (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Typography>لا توجد بيانات</Typography>
              </Box>
            )}
          </Box>
        </Box>

        {/* Row 2: Third pie chart */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 3,
            width: '100%'
          }}
        >
          <Box sx={{
            width: '50%',
            height: '395px',
            backgroundColor: '#fff',
            boxShadow: '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '5px',
            position: 'relative'
          }}>
            <span
              onClick={() => { }}
              className="hover-style"
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                cursor: 'pointer',
                paddingLeft: '10px',
                paddingRight: '10px',
                fontSize: '20px',
              }}>{`حالة المستندات الخارجية المراقبة ${dashboardObject?.total_external_monitored_completed + dashboardObject?.total_external_monitored_in_road}`}</span>
            {chartObject?.external_progress_pie?.series?.length > 0 && chartObject?.external_progress_pie?.labels?.length > 0 ? (
              <PieChart redirectIndex={(index) => showDetailsFromIndex(index, 2)} series={chartObject?.external_progress_pie?.series} labels={chartObject?.external_progress_pie?.labels} colors={chartObject?.external_progress_pie?.colors} />
            ) : (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Typography>لا توجد بيانات</Typography>
              </Box>
            )}
          </Box>
        </Box>

        {/* Row 3: Weight chart - All Mizans */}
        {roles?.view_total_weights_all?.value && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              width: '100%'
            }}
          >
            <Box sx={{
              width: '100%',
              minHeight: '500px',
              backgroundColor: '#fff',
              boxShadow: '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              borderRadius: '5px',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '20px'
            }}>
              {weightData?.weightData?.length > 0 && weightData?.weightLabels?.length > 0 ? (
                <StackChart 
                  title={`اجمالي الاوزان لكل ميزان`} 
                  data={weightData?.weightData} 
                  labels={weightData?.weightLabels} 
                  colors={[maintheme?.yellow, maintheme?.secondary, maintheme?.primary]}
                />
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <Typography>لا توجد بيانات</Typography>
                </Box>
              )}
            </Box>
          </Box>
        )}

        {/* Row 4: Weight chart - Port Category 1 (تحويلية) */}
        {roles?.view_total_weights_cat1?.value && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              width: '100%'
            }}
          >
            <Box sx={{
              width: '100%',
              minHeight: '500px',
              backgroundColor: '#fff',
              boxShadow: '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              borderRadius: '5px',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '20px'
            }}>
              {weightDataCat1?.weightData?.length > 0 && weightDataCat1?.weightLabels?.length > 0 ? (
                <StackChart 
                  title={`اجمالي الاوزان - تحويلية`} 
                  data={weightDataCat1?.weightData} 
                  labels={weightDataCat1?.weightLabels} 
                  colors={[maintheme?.yellow, maintheme?.secondary, maintheme?.primary]}
                />
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <Typography>لا توجد بيانات</Typography>
                </Box>
              )}
            </Box>
          </Box>
        )}

        {/* Row 5: Weight chart - Port Category 2 (مكبس) */}
        {roles?.view_total_weights_cat2?.value && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              width: '100%'
            }}
          >
            <Box sx={{
              width: '100%',
              minHeight: '500px',
              backgroundColor: '#fff',
              boxShadow: '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              borderRadius: '5px',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '20px'
            }}>
              {weightDataCat2?.weightData?.length > 0 && weightDataCat2?.weightLabels?.length > 0 ? (
                <StackChart 
                  title={`اجمالي الاوزان - مكبس`} 
                  data={weightDataCat2?.weightData} 
                  labels={weightDataCat2?.weightLabels} 
                  colors={[maintheme?.yellow, maintheme?.secondary, maintheme?.primary]}
                />
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <Typography>لا توجد بيانات</Typography>
                </Box>
              )}
            </Box>
          </Box>
        )}
 
        {/* Row 6: Mizan Weight Management chart - All Mizans */}
        {roles?.view_mizan_weight_management_all?.value && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              width: '100%'
            }}
          >
            <Box sx={{
              width: '100%',
              minHeight: '500px',
              backgroundColor: '#fff',
              boxShadow: '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              borderRadius: '5px',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '20px'
            }}>
              {mizanChartData?.series?.length > 0 && mizanChartData?.labels?.length > 0 ? (
                <StackChart 
                  title={t("TRANSACTIONS.manage_mizan_weight") || "تقرير اوزان الموازين"}
                  data={mizanChartData.series} 
                  labels={mizanChartData.labels} 
                  colors={[maintheme?.primary, maintheme?.secondary, maintheme?.yellow]}
                  initialHiddenSeries={['خارجي (بالطن)', 'داخلي (بالطن)']}
                />
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <Typography>لا توجد بيانات</Typography>
                </Box>
              )}
            </Box>
          </Box>
        )}

        {/* Row 7: Mizan Weight Management chart - Port Category 1 (تحويلية) */}
        {roles?.view_mizan_weight_management_cat1?.value && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              width: '100%'
            }}
          >
            <Box sx={{
              width: '100%',
              minHeight: '500px',
              backgroundColor: '#fff',
              boxShadow: '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              borderRadius: '5px',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '20px'
            }}>
              {mizanChartDataCat1?.series?.length > 0 && mizanChartDataCat1?.labels?.length > 0 ? (
                <StackChart 
                  title={`اوزان الموازين - تحويلية`}
                  data={mizanChartDataCat1.series} 
                  labels={mizanChartDataCat1.labels} 
                  colors={[maintheme?.primary, maintheme?.secondary, maintheme?.yellow]}
                  initialHiddenSeries={['خارجي (بالطن)', 'داخلي (بالطن)']}
                />
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <Typography>لا توجد بيانات</Typography>
                </Box>
              )}
            </Box>
          </Box>
        )}

        {/* Row 8: Mizan Weight Management chart - Port Category 2 (مكبس) */}
        {roles?.view_mizan_weight_management_cat2?.value && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              width: '100%'
            }}
          >
            <Box sx={{
              width: '100%',
              minHeight: '500px',
              backgroundColor: '#fff',
              boxShadow: '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              borderRadius: '5px',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '20px'
            }}>
              {mizanChartDataCat2?.series?.length > 0 && mizanChartDataCat2?.labels?.length > 0 ? (
                <StackChart 
                  title={`اوزان الموازين - مكبس`}
                  data={mizanChartDataCat2.series} 
                  labels={mizanChartDataCat2.labels} 
                  colors={[maintheme?.primary, maintheme?.secondary, maintheme?.yellow]}
                  initialHiddenSeries={['خارجي (بالطن)', 'داخلي (بالطن)']}
                />
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <Typography>لا توجد بيانات</Typography>
                </Box>
              )}
            </Box>
          </Box>
        )}

      </Box>)
}
